import { Injectable } from '@angular/core';
import { Constants } from '@models/constants';

@Injectable({
  providedIn: 'root',
})
export class CoveragesService {

  getCoverageLimitTerm(terms, type) {
    return terms.find((term) => term.termModelType === type);
  }
  getCoverageDeductableTerm(terms, type, coverageName?) {
    const deductibleTerm = terms.find((term) => term.termModelType === type);
    if (
      deductibleTerm &&
      coverageName === 'Personal Injury Protection (Per Person)' &&
      deductibleTerm.termAmount.toLowerCase() !== 'full coverage'
    ) {
        deductibleTerm.termAmount = deductibleTerm.termAmount
          .split('/')[0]
          .split(' ')[0];      
    }
    return deductibleTerm;
  }

  getBodilyInjuryToOthers(isOptional) {
    return {
      coverageName: `${isOptional ? 'Optional ': ''}Bodily Injury to Others (per person/accident)`,
      displayCovNamePartOne: `${isOptional ? 'Optional ': ''}Bodily Injury to Others`,
      displayCovNamePartTwo: Constants.PER_PERSON_ACCIDENT,
      coverageDescription: Constants.BODILY_INJURY_TO_OTHERS_DESC,
      coveragelink: Constants.LEARN_MORE,
      coverageURL: 'https://www.mapfreinsurance.com/blog/liability-car-insurance/'
    }
  }
}
